import React from "react";
import DownloadAllCSV from "./components/downloadAllCSV";
import SlaveAddressUtility from "./components/slaveAddressUtility";
import "./advanceTab.scss";

const Advanced = () => {
  return (
    <div style={{minHeight: "600px", padding: "10px 20px"}}>
      <SlaveAddressUtility />
      <div style={{margin: "20px 0px"}}>
        <DownloadAllCSV />
      </div>
    </div>
  );
};

export default Advanced;
